"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("../ExtendableError"));
/**
 * Thrown when SQL statement includes invalid identifier. See valid vendor
 * identifiers format for further information.
 * @param {string} explanation
 */
class InvalidSqlIdentifierError extends ExtendableError_1.default {
    constructor(identifier = '') {
        super(`Invalid SQL identifier: ${identifier} .`);
        this.identifier = identifier;
    }
}
exports.default = InvalidSqlIdentifierError;
